<template lang="pug">
  section.TourSupport
    <p class="TourSupport_content">{{ $t('tour.support.content') }}</p>
    <h2 class="TourSupport_title">{{ $t('tour.support.title') }}</h2>
    ButtonSimple(class="ButtonSimple_black" :href="$t('tour.support.link')" target="_blank")
      | {{ $t('tour.support.cta') }}
      SvgInline(src="extern")
</template>

<script>
import ButtonSimple from '@/components/common/ButtonSimple'

import SvgInline from '@/components/SvgInline'

export default {
  components: { ButtonSimple, SvgInline },
  data () {
    return {}
  },
  mounted () {

  }
}

</script>

<style lang="stylus" scoped>

.TourSupport

  position relative
  padding 110px 20px
  background-color $beige-l
  text-align center

  &_content

    font-weight 600
    font-size: 14px;
    letter-spacing: 5px;
    margin-bottom 30px

  .ButtonSimple

    margin-top 35px

</style>
